export const MAX_RESULTS_COUNT = 7;
